export default __webpack_public_path__ + "static/media/album_small.109f7953.png";